import { Globe, Mail, MessageCircle } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="max-w-5xl mx-auto px-6 py-4">
        <div className="text-center space-y-4">
          <div className="space-y-2">
           
            <p className="text-sm text-brand-gray">
              Contact Advis for expert digital transformation consulting
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 text-sm">
            <a 
              href="https://www.advis.com.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-brand-gray hover:text-brand-orange transition-colors duration-200"
            >
              <Globe className="h-4 w-4" />
              www.advis.com.au
            </a>
            
            <a 
              href="mailto:hello@advis.com.au"
              className="flex items-center gap-2 text-brand-gray hover:text-brand-orange transition-colors duration-200"
            >
              <Mail className="h-4 w-4" />
              hello@advis.com.au
            </a>
            
            <a 
              href="https://wa.me/61416720158"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-brand-gray hover:text-brand-green transition-colors duration-200"
            >
              <MessageCircle className="h-4 w-4" />
              +61 416 720 158
            </a>
          </div>
          
          <div className="pt-4 border-t border-gray-200">
            <p className="text-xs text-brand-gray">
              &copy; {currentYear} Digital Efficiency Audit. Powered by Advis.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}